<template>
  <div class="curriculumClasses">
    <div v-if="list.length > 0" class="curriculum-content">
      <div
        class="list-item"
        v-for="(item, index) in list"
        :key="index"
        @click="clickItem(item)"
      >
        <div class="list-item-top">
          <div class="list-item-title">
            <div class="list-item-title-text">{{ item.className }}</div>
            <van-icon name="arrow" size="0.2rem" color="#999" />
          </div>
        </div>
        <div class="list-item-bottom">
          <div class="bottm-content">
            <div class="label">培训时间</div>
            <div class="value">
              {{ item.trainingStartDate }} 至 {{ item.trainingEndDate }}
            </div>
          </div>

          <div class="bottm-content maringTopContent">
            <div class="label">班主任</div>
            <div class="value">{{ item.teacher ? item.teacher : "暂无" }}</div>
          </div>
        </div>
        <div class="line-grey" v-show="(list.length - 1) != index"></div>
      </div>
    </div>
    <div v-else class="arrange-nodata">
      <div class="nodatacontent">
        <img
          :src="require('_teas/public/img/product/bootScreen/img-null.png')"
          alt=""
          srcset=""
        />
        <div class="text">暂无课程</div>
      </div>
    </div>
    <van-dialog class="curriculum-shu-dialog" v-model="showDialog" :show-confirm-button="false" :show-cancel-button="false" :close-on-click-overlay="true" get-container="#app">
      <!-- <img class="dialog-closebutton" :src="require('_teas/public/img/product/bootScreen/icon-close.png')" alt="" srcset=""> -->
      <!-- <div class="dialog-closebutton" @click="clickDiaClose">x</div> -->
      <dsf-icon class="dialog-closebutton"  name="icon-close"  @click="clickDiaClose"></dsf-icon>
      <week-schedule :classInfor="classInfor" :classId="classInfor.classId"></week-schedule>
    </van-dialog>
  </div>
</template>

<script>

import weekSchedule from "./components/WeekSchedule.vue";
// 班级课程
export default {
  components: {
    weekSchedule,
  },
  data() {
    return {
      showDialog: false,
      list: [],
      classInfor: {
        classId: '',
        className: ''
      },
      screenType: 0, //屏幕类型：0为横向，1为纵向
    };
  },
  mounted() {
    this.screenType = this.$route.meta.screenType;
    this.getData();
  },
  methods: {
    clickDiaClose: function() {
      this.showDialog = false;
    },
    clickItem: function(item) {
      this.classInfor.classId = item['classId']
      this.classInfor.className = item['className']
      this.showDialog = true
    },
    //获取数据
    getData() {
      var loading = dsf.layer.loading();
      this.$http
        .get("teas/screen/classCurriculum")
        .done((res) => {
          if (res.success && res.state == 20000) {
            this.list = res.data;
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {
          this.$message("请求失败", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  },
};
</script>